import { createSelector } from 'reselect';

export const personalizationSetToSameValueSelector = (state) => {
  const {
    isPrepay,
    postpayRequiresSameValuePersonalization,
    prepayRequiresSameValuePersonalization,
  } = state.shoot;

  return (
    (isPrepay && prepayRequiresSameValuePersonalization) ||
    (!isPrepay && postpayRequiresSameValuePersonalization)
  );
};

export const cartItemsWithRequiredFieldsSelector = createSelector(
  (state) => state.v3Order.orders,
  (state) => state.additionalData.selectedStudent,
  (state) => state.shoot.shoot,
  (orders, selectedStudent, shootInfo) => {
    const shootEventId = shootInfo?.event_id || shootInfo?.id;
    const orderKey =
      shootEventId && selectedStudent?.id
        ? `${shootEventId}-${selectedStudent.id}`
        : null;
    const order = orderKey ? orders[orderKey] : null;

    if (!order) return [];

    const result = [];
    order.cartItems.forEach((item) => {
      if (item.requiredFields && item.requiredFields.length > 0) {
        result.push(item);
      }
      (item.children || []).forEach((child) => {
        if (child.requiredFields && child.requiredFields.length > 0) {
          result.push(child);
        }
      });
    });

    return result;
  },
);

// Returns a map of { [fieldId]: value } for all required fields across cart items and their children.
// When multiple items share the same field id, the last non-empty value wins.
export const requiredFieldValuesByIdSelector = createSelector(
  cartItemsWithRequiredFieldsSelector,
  (items) => {
    const result = {};
    items.forEach((item) => {
      (item.requiredFields || []).forEach((field) => {
        if (field.id != null && field.value != null && field.value !== '') {
          result[field.id] = field.value;
        }
      });
    });
    return result;
  },
);
